import React, {Fragment, memo} from "react";
import PropTypes from "prop-types";
import {useIsMobileOrTablet} from "../../hooks/useIsMobileOrTablet";
import SearchCreator from "../Forms/components/SearchCreator";
import Pagination from "../Table/components/Pagination";
import Table from "../Table/Table";
import CardList from "./CardList";
import NoDataFound from "./NoData";

/** This component will create table with search query component and pagination component.
 * This component will display cardList in mobile and ipad view
 */

const ListView = ({
  listItems = [],
  listHeaders = [],
  withSearchQuery = false,
  searchPlaceHolder = "Filter content",
  searchOptions = [],
  handleSearch = () => {},
  withActions = false,
  noDataText = "No Data Present",
  totalCount = 0,
  withPagination = false,
  ...rest
}) => {
  const {isMobileOrTablet} = useIsMobileOrTablet();

  return (
    <Fragment>
      {withSearchQuery && (
        <div
          style={{display: "flex", justifyContent: "flex-end"}}
          data-cy={"search-query"}
        >
          <div
            style={{
              marginBottom: "10px",
              marginRight: "-1rem",
              width: isMobileOrTablet ? "calc(100% + 1rem)" : "50%",
            }}
          >
            <SearchCreator
              placeholder={searchPlaceHolder}
              options={searchOptions}
              onChange={handleSearch}
            />
          </div>
        </div>
      )}
      {listItems && listItems.length > 0 ? (
        <div>
          {isMobileOrTablet ? (
            <CardList
              listHeaders={listHeaders}
              listItems={listItems}
              withActions={withActions}
              {...rest}
            />
          ) : (
            <Table
              headers={listHeaders}
              data={listItems}
              withActions={withActions}
              {...rest}
            />
          )}
          {withPagination && totalCount > 25 && (
            <Pagination
              totalCount={totalCount}
              currentPage={withPagination.currentPage}
              onPageChange={(currentPage) => {
                withPagination.onPageChange(currentPage);
              }}
            />
          )}
        </div>
      ) : (
        <NoDataFound
          headers={listHeaders}
          withActions={withActions}
          noDataText={noDataText}
        />
      )}
    </Fragment>
  );
};

ListView.propTypes = {
  /** Data which is need to be displayed */
  listItems: PropTypes.array.isRequired,
  /** List of headers to display on table */
  listHeaders: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Wether to display action column on table */
  withActions: PropTypes.bool,
  /** Wether to display search query component */
  withSearchQuery: PropTypes.bool,
  /** Placeholder for search query component */
  searchPlaceHolder: PropTypes.string,
  /** Options which will be passed to search query component */
  searchOptions: PropTypes.array,
  /** Callback function which will be executed after search query is created */
  handleSearch: PropTypes.func,
  /** Text to show no data is present */
  noDataText: PropTypes.string,
  /** Wether to display pagination for table */
  withPagination: PropTypes.shape({
    currentPage: PropTypes.number,
    onPageChange: PropTypes.func,
  }),
  /** Total number of elements in data this is needed for pagination */
  totalCount: PropTypes.number,
};

export default memo(ListView);
